import { forwardRef, useImperativeHandle, useState } from 'react';
import './style.scss';

export interface IHoneyPot {
  isValid: () => boolean;
}

// eslint-disable-next-line no-empty-pattern
export default forwardRef<IHoneyPot>(function HoneyPot({}, ref) {
  const [value, setValue] = useState('');

  useImperativeHandle(ref, () => ({
    isValid(): boolean {
      return !value;
    },
  }));

  return (
    <>
      <input
        type="text"
        name="h_phonenumber"
        className="tt-input"
        autoComplete="off"
        tabIndex={-1}
        style={{ left: '-1000px', position: 'absolute' }}
        aria-label="Phonenumber"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </>
  );
});
